import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const RiskExploration = lazy(() => import('@pages/landing/RiskExploration'));

export const RiskExplorationsRoutes: RouteObject[] = [
  {
    path: '/risk-exploration',
    element: (
      <React.Suspense>
        <RiskExploration />
      </React.Suspense>
    ),
  },
];
